<template>
  <template v-for="(item, i) in data">
    <slot :name="`prepend-${i}`" />
    <DynamicBlock :data="item" />
    <slot :name="`append-${i}`" />
  </template>
</template>

<script setup>
  defineProps({
    data: {}
  })
</script>
